import React, { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  createBankSlice,
  getBankListSlice,
  getBankByIdSlice,
  updateBankSlice,
  deleteBankSlice,
  resetCreateMessages,
  resetUpdateMessages,
  resetDeleteMessages,
} from "../../../store/slices/bankSlice";
import { getaccountType } from "../../../store/slices/accountType";
import { Modal } from "react-bootstrap";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import Table from "../../common/Table/table";
import AddUpdateBank from "./addupdatebank";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
import ViewModal from "../../common/viewModal/globalViewModal";

const Bank = () => {
  const dispatch = useDispatch();
  const [showModal, setModalVisible] = useState(false);
  const [showDeleteModal, setDeleteModalVisible] = useState(false);
  const [modalAction, setModalAction] = useState(null);
  const [deleteBank, setDeleteBank] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [showGlobalViewModal, setShowGlobalViewModal] = useState(false);
  const [showStatus, setShowStatus] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [pageLimit, setPageLimit] = useState(10);

  const [formData, setFormData] = useState({
    name: "",
    accountType: "",
    accountTypeName: "",
    status: "Active",
  });
  const [inputError, setInputError] = useState({
    name: "",
  });
  const showTostifyMessageAndReset = ShowTostifyMessageAndReset();
  const {
    bank,
    bankById,
    createBankSuccessMessage,
    createBankErrorMessage,
    updateBankSuccessMessage,
    updateBankErrorMessage,
    deleteBankSuccessMessage,
    deleteBankErrorMessage,
    loading,
    searchMessage,
    currentPage,
    totalPages,
    totalCount,

  } = useSelector((state) => state.bank);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { accountType } = useSelector((state) => state.accountType);
  const { token } = useSelector((state) => state.auth);
  const { tableStatus } = useSelector((state) => state.tableStatusChange);

  const clinicId =clinicInfo?.[0]?.clinicId; 

  const fetchBanks = useCallback(
    (page = 1, lim = pageLimit, search = searchValue) => {
      if (clinicId && token) {
        dispatch(
          getBankListSlice({
            clinicId,
            status: tableStatus,
            token,
            currentPage: page,
            limit: lim,
            bank: search || undefined,
          })
        );
        dispatch(getaccountType({ status: ["Active"], token }));
      }
    },
    [dispatch, clinicInfo, token, tableStatus, searchValue, pageLimit
    ]
  );
  useEffect(() => {
    fetchBanks();
  }, [fetchBanks, showModal, showGlobalViewModal]);

  const handlePageChange = (page) => {
    fetchBanks(page, pageLimit, searchValue);
  };
 const handleLimitChange = (newLimit) => {
    setPageLimit(newLimit);              
    fetchBanks(1, newLimit, searchValue); 
  };
  const tableHead = [
    { title: "Bank Name", key: "name" },
    { title: "Account Type", key: "accountType" },
    { title: "Status", key: "status" },
  ];

  useEffect(() => {
    showTostifyMessageAndReset(
      createBankSuccessMessage,
      showToastifySuccess,
      resetCreateMessages
    );
    showTostifyMessageAndReset(
      createBankErrorMessage,
      showToastifyError,
      resetCreateMessages
    );
    showTostifyMessageAndReset(
      updateBankSuccessMessage,
      showToastifySuccess,
      resetUpdateMessages
    );
    showTostifyMessageAndReset(
      updateBankErrorMessage,
      showToastifyError,
      resetUpdateMessages
    );
    showTostifyMessageAndReset(
      deleteBankSuccessMessage,
      showToastifySuccess,
      resetDeleteMessages
    );
    showTostifyMessageAndReset(
      deleteBankErrorMessage,
      showToastifyError,
      resetDeleteMessages
    );
  }, [
    createBankSuccessMessage,
    createBankErrorMessage,
    updateBankSuccessMessage,
    updateBankErrorMessage,
    deleteBankSuccessMessage,
    deleteBankErrorMessage,
    showTostifyMessageAndReset,
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setInputError((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleModal = (action, bank = null) => {
    if (action === "create") {
      setFormData({
        id: "",
        accountType: "",
        accountTypeName: "",
        name: "",
        status: "Active",
      });
    } else if (action === "edit" && bank) {
      setFormData({
        id: bank?._id,
        name: bank?.name,
        accountType: bank.accountType?._id,
        accountTypeName: bank.accountType?.name,
        status: bank?.status,
      });
    }
    setModalVisible(true);
    setModalAction(action);
  };

  const handleAddOrUpdateBank = async (e) => {
    e.preventDefault();
    try {

      if (!formData.name.trim()) {
        setInputError({
          name: "Name is required**",
        });
        return;
      }
      setSubmitLoading(true);
      if (modalAction === "create") {
        await dispatch(
          createBankSlice({
            ...formData,
            clinicId,
            token,
          })
        );
      } else {
        await dispatch(
          updateBankSlice({
            ...formData,
            clinicId,
            token,
          })
        );

        await dispatch(
          getBankListSlice({
            clinicId,
            status: tableStatus,
            token,
          })
        );
      }

      setModalVisible(false);
      setFormData({
        id: "",
        name: "",
        accountType: "",
        status: "Active",
      });
    } catch (error) {
      console.error("Error occurred while handling bank operation:", error);
    } finally {
      setSubmitLoading(false); 
    }
  };

  const handleUpdateStatus = async (status, item) => {
    try {
      const updateData = {
        id: item?.id,
        name: item?.name,
        accountType: item?.accountTypeId,
        accountTypeName: item?.accountType,
        status: status,
        clinicId,
        token,
      };

    await dispatch(updateBankSlice(updateData));
    fetchBanks(currentPage, pageLimit, searchValue);
  } catch (error) {
    console.error(error);
  }
};

  const handleSearch = useCallback(
    (e) => {
      const value = e.target.value;
      setSearchValue(value);
      fetchBanks(1, pageLimit, value);
    },
    [fetchBanks, pageLimit]
  );

  const handleEdit = (bank) => {
    handleModal("edit", bank);
    setFormData({
      id: bank?.id,
      name: bank?.name,
      accountType: bank?.accountTypeId,
      accountTypeName: bank?.accountType,
      status: bank?.status,
    });
  };

  const handleSelectChange = (selectedOption, name) => {
    setFormData((prev) => ({
      ...prev,
      [name]: selectedOption.value,
    }));

    if (name === "accountType") {
      setFormData((prev) => ({
        ...prev,
        accountType: selectedOption.value,
        accountTypeName: selectedOption.label,
      }));
    }
  };

  const handleShowGlobalViewModal = async (data) => {
    await dispatch(
      getBankByIdSlice({
        id: data?.id,
        clinicId,
        token,
      })
    );
    setShowGlobalViewModal(true);
  };

  const handleDeleteBank = async () => {
    try {
      await dispatch(
        deleteBankSlice({
          id: deleteBank,
          clinicId,
          token,
        })
      );
      setDeleteModalVisible(false);
      dispatch(
        getBankListSlice({
          clinicId,
          token,
          status: tableStatus,
        })
      );
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };

  const handleDelete = (Id) => {
    setDeleteBank(Id.id);
    setDeleteModalVisible(true);
  };

  return (
    <div className="container mt-4">
      <Table
        tableHead={tableHead}
        tableBody={
          bank &&
          bank.map((item) => ({
            id: item?._id,
            name: item?.name || "N/A",
            accountType: item?.accountType?.name || "N/A",
            accountTypeId: item?.accountType?._id || "N/A",
            status: item?.status || "N/A",
          }))
        }
        handleAddBtn={true}
        handleSearchOption={true}
        searchValue={searchValue}
        handleSearch={handleSearch}
        handleDelete={handleDelete}
        handleDeleteBank={handleDeleteBank}
        errorMessage={searchMessage}
        handleEdit={handleEdit}
        addModal={() => handleModal("create")}
        handleShowGlobalViewModal={handleShowGlobalViewModal}
        showStatus={showStatus}
        setShowStatus={setShowStatus}
        handleUpdateStatus={handleUpdateStatus}
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        limit={pageLimit}
        onPageChange={handlePageChange}
        onLimitChange={handleLimitChange}
        showPagination={true}
        showLimitDropdown={true}
        isLoading={loading}
      />
      <AddUpdateBank
        handleChange={handleChange}
        setModalVisible={setModalVisible}
        showModal={showModal}
        modalAction={modalAction}
        handleAddOrUpdateBank={handleAddOrUpdateBank}
        formData={formData}
        handleEdit={handleEdit}
        handleSelectChange={handleSelectChange}
        accountType={accountType}
        setInputError={setInputError}
        inputError={inputError}
        submitLoading={submitLoading}
      />
      <Modal
        centered
        show={showDeleteModal}
        onHide={() => setDeleteModalVisible(false)}
        size="md"
      >
        <div className="modal-header">
          <h5 className="modal-title">Delete AccountType</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setDeleteModalVisible(false)}
          ></button>
        </div>
        <div className="modal-body">
          <p>Are you sure you want to delete this Bank?</p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setDeleteModalVisible(false)}
          >
            Close
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleDeleteBank}
          >
            Delete
          </button>
        </div>
      </Modal>
      <ViewModal
        showGlobalViewModal={showGlobalViewModal}
        setShowGlobalViewModal={setShowGlobalViewModal}
        modalSize={"lg"}
        titel={tableHead}
        content={{
          id: bankById?._id,
          name: bankById?.name,
          accountType: bankById?.accountType?.name,
          status: bankById?.status,
        }}
      />
    </div>
  );
};

export default Bank;
